module.exports = __webpack_public_path__ + "img/uv_0.e85635fe.png";